"use strict";
var $ = require("../internals/export");
var hasOwn = require("../internals/has-own-property");
$({ target: "Object", stat: true }, {
  hasOwn
});
